// extracted by mini-css-extract-plugin
module.exports = {"tooltip":"_9400a595a7--tooltip--iUFWc","item":"_9400a595a7--item--HZ37Y"};